var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaterials(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fill-only",
    d: "M16.0301 4.99556H11.5044V0.469867C11.5044 0.210311 11.2943 0 11.0346 0H5.96453C5.70498 0 5.49467 0.210133 5.49467 0.469867V4.99556H0.968978C0.710311 4.99556 0.5 5.20569 0.5 5.46542V10.5355C0.5 10.7943 0.710311 11.0044 0.968978 11.0044H5.49467V15.5301C5.49467 15.7897 5.70498 16 5.96453 16H11.0346C11.2943 16 11.5044 15.7897 11.5044 15.5301V11.0044H16.0301C16.289 11.0044 16.5 10.7941 16.5 10.5355V5.46542C16.5 5.20569 16.2888 4.99556 16.0301 4.99556ZM15.5601 10.0656H11.0346C10.775 10.0656 10.5647 10.2759 10.5647 10.5355V15.061H6.4344V10.5355C6.4344 10.2759 6.22427 10.0656 5.96453 10.0656H1.43884V5.9344H5.96453C6.22427 5.9344 6.4344 5.72409 6.4344 5.46542V0.938845H10.5647V5.46524C10.5647 5.72409 10.775 5.93422 11.0346 5.93422H15.5603V10.0656H15.5601Z",
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterials);
export default __webpack_public_path__ + "static/media/materials.61b178fd2a75c66c4c874f0a8f7b7225.svg";
export { ForwardRef as ReactComponent };